const env = (window as any).__env || {};

export const environment = {
  apiUrl: env.api_url || '',
  production: env.production ?? false,
};
